
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventBus } from '@/eventBus';
import { StoreModel } from '@/models/store';
import { EventHandler } from '@/modules/events';
import { put } from '@/services/http';
import { optInToAtlas, OptInSource } from '@/services/frontendAppOptIn';

/**
 * AS-11272 M6 — the confirm step of the opt-in (design §4.1: the move is per
 * store, so the dialog says it applies to every staff account). On success the
 * page leaves through the shell guard, so the button stays in its loading
 * state; on failure the bot's message goes to the snackbar and the dialog
 * stays open.
 */
@Component
export default class AtlasOptInDialog extends Vue {
  @Prop({ default: false })
  public value!: boolean;
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: 'settings' })
  public source!: OptInSource;

  public switching: boolean = false;

  public close() {
    this.$emit('input', false);
  }

  public async confirm() {
    if (this.switching) return;
    this.switching = true;
    const result = await optInToAtlas(this.store, this.source, {
      put,
      track: (event, props, options) => new EventHandler({ store: this.store }).track(event, props, options),
    });
    if (!result.ok) {
      this.switching = false;
      EventBus.$emit('show-snackbar', { message: result.message, color: 'error' });
      return;
    }
    this.$emit('switched');
  }
}
